import { BaseIcon } from './base-icon.js';
import { svg } from 'lit';

/**
 * Error Icon Component
 * Circle with X mark (outline style)
 * Used for error messages and failed operations
 */
class ErrorIcon extends BaseIcon {
    getSvgAttributes() {
        return {
            xmlns: 'http://www.w3.org/2000/svg',
            viewBox: '0 0 24 24',
            fill: 'none',
            stroke: 'currentColor',
            'stroke-width': '2',
        };
    }

    renderIconPath() {
        return svg`
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
            />
        `;
    }
}

customElements.define('error-icon', ErrorIcon);
